import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { TimerName, TimeState } from './interfaces'

const initialState: TimeState = {
  timers: {
    now30s: Date.now()
  }
}

const time = createSlice({
  name: 'time',
  initialState,
  reducers: {
    updateTimer: (state, { payload }: PayloadAction<TimerName>) => {
      state.timers[payload] = Date.now()
    }
  }
})

export const {
  updateTimer
} = time.actions

export default time.reducer
